import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// Slice
import { setActiveLoginModal, setLms } from '../../app/features/userSlice';
// Components
import Container from '../Container';
// Services
import { autenticationURL } from '../../services/Login/getInstitutionData';
// Images
import { IoMdClose } from 'react-icons/io';
import imageLogin from '../../Images/Login/ImageModal.webp';
// Images
import logoHeaderHome from '../../Images/logo/logo_OlibBlack.svg';
import AquinoImage from '../../Images/Login/Modal/Aquino.png';
import iconModal from '../../Images/Login/Modal/IconModal.svg';
import CanvasLogo from '../../Images/canvas_logo.png';
import WordpressLogo from '../../Images/login-wordpress.png';
import MoodleLogo from '../../Images/moodle-logo.webp';
import TalentLMSLogo from '../../Images/talent-lms-logo.png';
import DigitalOceanLogo from '../../Images/digital-ocean-logo.png';
import AquinoLogo from '../../Images/aquino-bottom2.png';
import BlackboardLogo from '../../Images/blackboard-logo.jpeg';
import D2lLogo from '../../Images/d2l-logo.png';
// Styles
import './LoginModal.css';
// Translate
import { useTranslation } from 'react-i18next';

const LoginModal = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const dispatch = useDispatch();
	const { institutionCode, assignedLogin, isActive } = useSelector(
		(state) => state.institution,
	);

	const loginButtonName = (name) => {
		const isUnique = name === 'unique';
		const baseName = isUnique
			? institutionCode === 'CMVC'
				? `${t('Login with')} moodle`
				: t('Unique login')
			: `${t('Login with')} ${name}`;
		return baseName;
	};

	const getLogin = (login) => {
		dispatch(setActiveLoginModal(false));
		if (login === 'unique' || login === 'talent') {
			navigate('login');
		} else if (login === 'canvas' || login === 'moodle') {
			dispatch(setLms(login));
			window.location.href = autenticationURL(login, institutionCode);
		} else if (login === 'moodle 2.9') {
			dispatch(setLms('moodle 2.9'));
			window.location.href = autenticationURL(login, `${institutionCode}_2`);
		} else if (login === 'digitalocean') {
			dispatch(setLms(login));
			window.location.href = autenticationURL(login, institutionCode);
		} else if (login === 'blackboard') {
			dispatch(setLms(login));
			window.location.href = autenticationURL(login, institutionCode);
		} else if (login === 'populi') {
			dispatch(setLms(login));
			window.location.href = autenticationURL(login, institutionCode);
		} else if (login === 'd2l' || login === 'brightspace') {
			dispatch(setLms(login));
			window.location.href = autenticationURL(login, institutionCode);
		} else if (login === 'wordpress') {
			navigate('login-with-wordpress');
		}
	};

	const formatProviders = (providers) => {
		if (!providers || providers.length === 0) return '';

		const labels = providers.map((p) => (p === 'unique' ? 'unique login' : p));

		if (labels.length === 1) return labels[0];
		if (labels.length === 2) return `${labels[0]} or ${labels[1]}`;

		return `${labels.slice(0, -1).join(', ')}, or ${labels.at(-1)}`;
	};

	return (
		<div className='loginHomeModal'>
			<Container>
				<div
					className={isActive ? 'modal-content' : 'modal-content Deactivate'}
				>
					<button
						className='closeButton'
						onClick={() => dispatch(setActiveLoginModal(false))}
					>
						<IoMdClose />
					</button>

					{isActive ? (
						<>
							<div className='imageContent'>
								<img src={imageLogin} alt='Modal login' />
								<div className='imageText'>
									<p>
										Your Unified Portal to <b>Aquinas Online Library</b>
									</p>
									<p>
										Find books, scholarly articles, and exclusive resources by
										exploring hundreds of library databases worldwide. <br />
										Thanks to our built-in artificial intelligence, perform
										faster, more accurate searches tailored to your needs
									</p>
								</div>
							</div>

							<div className='textContent'>
								<img src={logoHeaderHome} alt='logo Aquinas' />
								<div className='flex justify-center max-w-[300px] lg:max-w-[450px]'>
									<p className='text-center text-lg font-light lg:text-2xl'>
										Log in to the library using your{' '}
										<b className='font-semibold'>
											{formatProviders(assignedLogin)} account credentials.
										</b>
									</p>
								</div>

								<div className='loginButtonModalContainer flex flex-wrap gap-2'>
									{assignedLogin?.map((login, i) => (
										<button
											onClick={() => getLogin(login)}
											key={`${login}-${i}`}
											className='bg-green-aquinas rounded-full px-4 py-2 flex items-center gap-x-4 justify-center text-white hover:scale-105 transition-all duration-300'
										>
											{loginButtonName(login)}
											{console.log('login', login)}

											{login === 'canvas' && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={CanvasLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px]'
													/>
												</div>
											)}

											{login === 'wordpress' && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={WordpressLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px] invert'
													/>
												</div>
											)}

											{(login === 'd2l' || login === 'brightspace') && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={D2lLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px]'
													/>
												</div>
											)}

											{(login === 'moodle' || login === 'moodle 2.9') && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={MoodleLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px]'
													/>{' '}
												</div>
											)}

											{login === 'talent' && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={TalentLMSLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px]'
													/>{' '}
												</div>
											)}

											{login === 'digitalocean' && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={DigitalOceanLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px]'
													/>{' '}
												</div>
											)}

											{login === 'blackboard' && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={BlackboardLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[25px]'
													/>{' '}
												</div>
											)}

											{login === 'unique' && (
												<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
													<img
														src={AquinoLogo}
														alt='logo Aquinas'
														className='w-full max-h-[25px] max-w-[22px]'
													/>{' '}
												</div>
											)}
										</button>
									))}
								</div>
							</div>
						</>
					) : (
						<div>
							<div className='noActiveContent'>
								<img src={AquinoImage} alt='logo Aquinas' />
								<div className='info'>
									<img src={iconModal} alt='icon' />
									<p>We want to see you back</p>
								</div>
							</div>
							<p className='infoText'>
								We just wanted to remind you that{' '}
								<b>your annual subscription has expired</b>. It was a pleasure
								having you this year. If you enjoyed your experience, please
								renew your subscription and continue enjoying all the benefits
								of our bookstore. We look forward to seeing you again!
							</p>
						</div>
					)}
				</div>
			</Container>
		</div>
	);
};

export default LoginModal;
